import { boolean, object, string } from '@gogame/schemas';

import { columnsSchema } from './columnsSchema';
import { filtersSchema } from './filtersSchema';
import { tableSettingsSchema } from './tableSettingsSchema';

export const screenSchema = object({
  filters: filtersSchema,
  tableSettings: tableSettingsSchema,
  columns: columnsSchema,
  searchQuery: string(),
  ready: boolean().default(true),
});
